/** Crawlable area landing pages at /activities/:area. Districts must match venue district values exactly. */
export interface AreaHub {
  slug: string;
  name: string;
  districts: string[];
  title: string;
  description: string;
  intro: string[];
}

export const AREA_HUBS: AreaHub[] = [
  {
    slug: "balham",
    name: "Balham",
    districts: ["Balham"],
    title: "Baby & Toddler Activities in Balham | Balham Babes",
    description: "Baby and toddler classes, playgroups, soft play and baby-friendly cafés in Balham, SW12. See what's on this week and which local parents and carers are going.",
    intro: [
      "Balham is full of things to do with babies and toddlers — from music and movement classes and baby yoga to free stay-and-play sessions, parks and cafés with a play corner.",
      "Every listing below is checked and kept up to date by our team, so you can see days, times, ages and prices at a glance, and find other parents and carers going too.",
    ],
  },
  {
    slug: "clapham",
    name: "Clapham",
    districts: ["Clapham", "Clapham Common", "Clapham Park", "Clapham North", "Clapham South", "Clapham Junction"],
    title: "Baby & Toddler Activities in Clapham | Balham Babes",
    description: "Baby and toddler classes, playgroups, soft play and baby-friendly cafés in Clapham, SW4. Find sessions around Clapham Common and see who's going.",
    intro: [
      "From Clapham Common to Clapham Park, there's a lot on for little ones — sensory and music classes, sports and active play, playgroups, and baby-friendly cafés.",
      "Browse everything happening in Clapham below, with days, times, ages and prices, and see which local parents and carers are planning to go.",
    ],
  },
  {
    slug: "tooting",
    name: "Tooting",
    districts: ["Tooting", "Tooting Bec", "Tooting Broadway", "Upper Tooting"],
    title: "Baby & Toddler Activities in Tooting | Balham Babes",
    description: "Baby and toddler classes, playgroups, soft play and baby-friendly cafés in Tooting, SW17. See what's on this week and which local parents and carers are going.",
    intro: [
      "Tooting has plenty for little ones — from Tooting Bec Common and the Lido to music classes, stay-and-plays and family-friendly cafés along the high street.",
      "Browse everything happening in Tooting below, with days, times, ages and prices, and see which local parents and carers are planning to go.",
    ],
  },
  {
    slug: "streatham",
    name: "Streatham",
    districts: ["Streatham"],
    title: "Baby & Toddler Activities in Streatham | Balham Babes",
    description: "Soft play, swimming, paddling pools and baby and toddler activities in Streatham, SW16. See what's on and which local parents and carers are going.",
    intro: [
      "Streatham is home to some of South London's best soft play for little ones, plus swimming at the leisure centre and summer splashing at the Rookery paddling pool on Streatham Common.",
      "Every listing below is checked and kept up to date by our team, and we're adding more Streatham activities all the time.",
    ],
  },
];

/** Category landing pages at /activities/:area/:category. `names` are activity category names. */
export interface CategoryHub { slug: string; label: string; heading: string; names: string[]; blurb: string }

export const CATEGORY_HUBS: CategoryHub[] = [
  { slug: "baby-toddler-classes", label: "Classes", heading: "Baby & Toddler Classes", names: ["Classes", "Music & Movement", "Sports & Active Play", "Language Development"], blurb: "music, sensory, dance, gymnastics, sports and language classes for babies and toddlers" },
  { slug: "playgroups", label: "Playgroups", heading: "Playgroups & Stay-and-Plays", names: ["Indoor Playgroup", "Outdoor Playgroup", "Stay and Play"], blurb: "free and low-cost playgroups and stay-and-play sessions" },
  { slug: "soft-play", label: "Soft Play", heading: "Soft Play", names: ["Soft Play Venue"], blurb: "soft play venues for babies, toddlers and little ones" },
  { slug: "baby-friendly-cafes", label: "Cafés", heading: "Baby-Friendly & Play Cafés", names: ["Baby Friendly Cafe", "Cafe Play"], blurb: "baby-friendly cafés and play cafés with space for buggies and little ones" },
  { slug: "postnatal-fitness", label: "Postnatal Fitness", heading: "Postnatal Fitness & Mum and Baby Exercise", names: ["Postnatal Fitness"], blurb: "postnatal fitness, yoga and Pilates classes you can bring your baby to" },
];

export const findCategoryHub = (slug?: string) => CATEGORY_HUBS.find((c) => c.slug === slug?.toLowerCase());

export const findAreaHub = (slug?: string) => AREA_HUBS.find((h) => h.slug === slug?.toLowerCase());
